<template>
  <div class="box">
    <article class="media">
      <div class="media-left status"
        v-bind:class="{ complete: isCompleted }" >
        <!-- {{ statusId }} -->
        <bars
          v-if="!isCompleted"
          v-bind:data="[statusUnstarted + 1, statusProgress + 1, statusCompleted + 1]"
          :gradient="['#F5C423', '#7CB141']"
          :barWidth="10"
          :width="50"
          :height="120"
          :rounding="2"
          :growDuration="1" >
        </bars>
        </div>
      <div class="media-content">
        <div class="content">
          <p>
            <span class="card-title">{{ cardTitle }}</span>
            <br>
            <span class="card-detail-label">Status:</span> {{ statusText }} -
            <span class="readyForDev-label"> {{ statusUnstarted }}%</span> Unstarted
            <span class="readyForDeploy-label"> {{ statusProgress }}%</span> In-progress,
            <span class="completed-label"> {{ statusCompleted }}%</span> Completed<br>
            <span class="card-detail-label">Owner:</span> {{ cardOwner }}<br>
            <!-- eslint-disable-next-line -->
            <span class="card-detail-label">Last Updated:</span> {{ cardDate | moment("MM.DD.YYYY") }}<br>
            <span v-if="cardDescription !== ''">
              <img class="desc-icon" src="../assets/icon-document.svg" />
              <span class="desc-label">
                &nbsp;<a v-on:click="toggleDescription">Click for Description</a>
              </span>
            </span><br>
          </p>
        </div>
      </div>
    </article>
    <Info class="info-block"
      v-bind:class="{ 'show-info': showInfo }"
      v-bind:title="cardTitle"
      v-bind:subtitle="cardOwner"
      v-bind:body="cardDescription"
      v-bind:avatar="cardOwnerAvatar"
      v-on:closeInfo="hideDescription"/>
  </div>
</template>

<script>
import Info from './Info.vue';

export default {
  name: 'Card',
  components: {
    Info,
  },
  props: {
    id: {
      type: Number,
      default: 0,
      required: true,
    },
    statusId: {
      type: Number,
      default: 0,
      required: true,
    },
    statusColor: {
      type: String,
      required: true,
    },
    statusText: {
      type: String,
      default: '',
    },
    statusProgress: {
      type: Number,
      default: 0,
      required: true,
    },
    statusCompleted: {
      type: Number,
      default: 0,
      required: true,
    },
    statusUnstarted: {
      type: Number,
      default: 0,
      required: true,
    },
    cardTitle: {
      type: String,
      default: 'Title',
      required: true,
    },
    cardDescription: {
      type: String,
      default: '',
      required: false,
    },
    cardOwner: {
      type: String,
      default: '',
    },
    cardOwnerAvatar: {
      type: String,
      default: '',
      required: false,
    },
    cardDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  computed: {
    isCompleted() {
      let isComplete = false;
      if (this.statusCompleted === 100) {
        isComplete = true;
      }
      return isComplete;
    },
  },
  methods: {
    toggleDescription() {
      if (this.showInfo === false) {
        this.showInfo = true;
      } else {
        this.showInfo = false;
      }
    },
    hideDescription() {
      this.showInfo = false;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../styles/common.scss';

  .unknown {
    background-color: $shape-log-light-gray;
  }
  .unstarted {
    background-color: $shape-log-red;
  }
  .readyForDev {
    background-color: $shape-log-orange;
  }
  .inDev {
    background-color: $shape-log-yellow;
  }
  .readyForReview {
    background-color: $shape-log-altyellow;
  }
  .readyForDeploy {
    background-color: $shape-log-blue;
  }
  .completed {
    background-color: $shape-log-green;
  }

  .unknown-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-light-gray;
  }
  .unstarted-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-red;
  }
  .readyForDev-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-orange;
  }
  .inDev-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-yellow;
  }
  .readyForReview-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-altyellow;
  }
  .readyForDeploy-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-blue;
  }
  .completed-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-green;
  }

  .card-detail-label {
    font-weight: $font-weight-semibold;
    color: $shape-log-dark-gray;
  }

  .box {
    color: $shape-log-dark-gray;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    max-width: 768px;
    margin-bottom: 10px !important;
    .media {
      .media-left {
        min-width: 72px;
        min-height: 170px;
        font-size: 48px;
        font-weight: $font-weight-black;
        color: $white;
        margin: 0;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 20px;
        padding-bottom: 0px;
        border-right: 1px solid #CCCCCC;
        background-color: #434343;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;

        &.complete {
          background-image: url('../assets/icon-check-circle.svg');
          background-position: center;
          background-size: 50%;
          background-repeat: no-repeat;
        }
      }
      .media-content {
        padding: 15px;
        .content {
          .card-title {
            color: $shape-log-blue;
            font-weight: $font-weight-semibold;
            font-size: 18px;
            line-height: 2;
          }

          .desc-icon {
            vertical-align: middle;
          }

          .desc-label {
            vertical-align: middle;
            a {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .info-block {
    display: none;

    &.show-info {
      display: block;
    }
  }
</style>
